import React from 'react'
import { Col, Row } from 'react-bootstrap'

export const ErrorMessage = ({ error }) => {
    return (
        <>
            <div className="container pt-5 pb-2">
                <div className="custom-template " >

                    <Row>
                        <Col sm={8} md={8} lg={10} xl={10} >
                            <img
                                width={270}
                                height={270}
                                alt='poonalogo.jpg'
                                src="./poonalogo.jpg"
                                className="img-fluid"
                            ></img>
                        </Col>
                    </Row>
                    <div className="alert alert-danger overflow-hidden text-center" role="alert">
                        <h4 className="alert-heading ">❌ Something Went wrong!</h4>
                        <hr></hr>
                        Error - {error}
                    </div>
                </div>
            </div>
        </>
    )
}
